import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export interface IconNamespaceRegistration {
  [namespace: string]: { [name: string]: string };
}

interface IconNamespaceRegistrationResult {
  namespace: string;
  name: string;
  filename: string;
}

export function flatten(registry: IconNamespaceRegistration): IconNamespaceRegistrationResult[] {
  return Object.entries(registry).reduce<IconNamespaceRegistrationResult[]>((prev, next) => {
    const [namespace, icoObj] = next;
    const nsIcons: IconNamespaceRegistrationResult[] = Object.entries(icoObj).map(
      ([name, filename]) => {
        return {
          namespace,
          name,
          filename,
        };
      },
    );
    return [...prev, ...nsIcons];
  }, []);
}

export function registerIcons(
  iconsToRegister: IconNamespaceRegistration,
  iconRegistration: MatIconRegistry,
  domSanitizer: DomSanitizer,
) {
  const registrations = flatten(iconsToRegister);
  registrations.forEach((icon) => {
    iconRegistration.addSvgIconInNamespace(
      icon.namespace,
      icon.name,
      domSanitizer.bypassSecurityTrustResourceUrl(icon.filename),
    );
  });
}
